<template>
  <div class="config">
    <Form :model="config" :rules="configValidate" action="javascript:void(0)">
      <FormItem label="今日购票总量">
        <Input v-model="config.ticketnum"></Input>
      </FormItem>
      <FormItem label="今日检票量">
        <Input v-model="config.checkticketnum"></Input>
      </FormItem>
      <FormItem label="今日参观总数">
        <Input v-model="config.visitornum"></Input>
      </FormItem>
      <FormItem label="2015年累计游客数量">
        <Input v-model="config.yearnum1"></Input>
      </FormItem>
      <FormItem label="2016年累计游客数量">
        <Input v-model="config.yearnum2"></Input>
      </FormItem>
      <FormItem label="2017年累计游客数量">
        <Input v-model="config.yearnum3"></Input>
      </FormItem>
      <FormItem label="2018年累计游客数量">
        <Input v-model="config.yearnum4"></Input>
      </FormItem>
      <FormItem label="2019年累计游客数量">
        <Input v-model="config.yearnum5"></Input>
      </FormItem>
      <FormItem label="2020年累计游客数量">
        <Input v-model="config.yearnum6"></Input>
      </FormItem>
      <FormItem label="2021年累计游客数量">
        <Input v-model="config.yearnum7"></Input>
      </FormItem>
      <FormItem label="女性参观量">
        <Input v-model="config.sexnum1"></Input>
      </FormItem>
      <FormItem label="男性参观量">
        <Input v-model="config.sexnum2"></Input>
      </FormItem>
      <FormItem label="7-12岁累计游客数量">
        <Input v-model="config.agenum1"></Input>
      </FormItem>
      <FormItem label="13-17岁累计游客数量">
        <Input v-model="config.agenum2"></Input>
      </FormItem>
      <FormItem label="18-45岁累计游客数量">
        <Input v-model="config.agenum3"></Input>
      </FormItem>
      <FormItem label="45-69岁累计游客数量">
        <Input v-model="config.agenum4"></Input>
      </FormItem>
      <FormItem label="70岁以上累计游客数量">
        <Input v-model="config.agenum5"></Input>
      </FormItem>
      <FormItem>
        <Select v-model="config.provincenum" clearable multiple placeholder="省">
          <Option v-for="item in shengList" :value="item.id" :key="item.id">{{item.areaname}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit()">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>


<script>
export default {
  name: "config",
  data() {
    return {
      config: {
        sitename: "",
        describe: "",
        person: "",
        phone: "",
        email: "",
        address: "",
        made_deposit: 0,
        park_service_charge: 0
      },
      shengList: [],
      configValidate: {}
    };
  },
  created: function() {
    this.getConfig();
    this.getShengList();
  },
  methods: {
    handleSubmit() {
      this.$api.screen.updinfomation(this.config).then(res => {
        if (res.code == 200) {
          this.$Message.success("修改成功...");
        }
      });
    },
    getConfig: function() {
      this.$api.screen.infomation().then(res => {
        this.config = res.result;
      });
    },
    getShengList() {
      this.$api.intangibleItem.areaList({ id: 0 }).then(res => {
        if (res.code == 200) {
          this.shengList = res.result;
        }
      });
    }
  }
};
</script>
